import React from "react";
import { motion } from "framer-motion";

const ContactUs = () => {
  return (
    <section className="relative py-20 px-4 md:px-10 lg:px-20 bg-gradient-to-br from-[#fdfbfb] to-[#ebedee] overflow-hidden">
      
      {/* Background Glow */}
      <div className="absolute -top-40 -left-40 w-[400px] h-[400px] bg-[#F5B800]/20 rounded-full blur-3xl"></div>
      <div className="absolute -bottom-40 -right-40 w-[400px] h-[400px] bg-[#C0392B]/20 rounded-full blur-3xl"></div>

      {/* Header */}
      <div className="max-w-6xl mx-auto text-center mb-14 relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 tracking-tight">
          Contact Us
        </h2>
        <div className="w-24 h-1 bg-gradient-to-r from-[#F5B800] to-[#C0392B] mx-auto rounded-full"></div>
        <p className="mt-5 text-gray-600 max-w-2xl mx-auto text-lg leading-relaxed">
          We'd love to hear from you. Reach out for admissions, queries, or collaborations.
        </p>
      </div>

      {/* Card */}
      <motion.div 
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-5 rounded-3xl overflow-hidden shadow-2xl border border-white/30 backdrop-blur-lg bg-white/60"
      >
        
        {/* LEFT SIDE */}
        <div className="lg:col-span-2 bg-gradient-to-br from-[#C0392B] to-[#922B21] text-white p-10 flex flex-col justify-center relative">
          
          <h3 className="text-2xl font-semibold mb-10 text-[#F5B800] tracking-wide">
            Get In Touch
          </h3>

          <div className="space-y-10">

            {/* Phone */}
            <div className="flex items-start gap-4 group">
              <div className="p-3 rounded-full bg-white/10 group-hover:bg-[#F5B800]/20 transition">
                <svg className="w-6 h-6 text-[#F5B800]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeWidth="2" d="M3 5a2 2 0 012-2h3.28l1.5 4.5-2.5 1.2a11 11 0 005.5 5.5l1.2-2.5 4.5 1.5V19a2 2 0 01-2 2h-1C9.7 21 3 14.3 3 6z"/>
                </svg>
              </div>
              <div>
                <p className="text-sm text-red-100 uppercase tracking-wider font-semibold">Call / WhatsApp</p>
                {/* Changed to anchor tags with tel: protocol */}
                <a href="tel:+919964451828" className="block text-lg font-medium hover:text-[#F5B800] cursor-pointer transition mt-1">
                  +91 99644 51828
                </a>
                <a href="tel:+918884618113" className="block text-lg font-medium hover:text-[#F5B800] cursor-pointer transition">
                  +91 88846 18113
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="flex items-start gap-4 group">
              <div className="p-3 rounded-full bg-white/10 group-hover:bg-[#F5B800]/20 transition">
                <svg className="w-6 h-6 text-[#F5B800]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeWidth="2" d="M3 8l9 6 9-6M5 19h14V7H5z"/>
                </svg>
              </div>
              <div>
                <p className="text-sm text-red-100 uppercase tracking-wider font-semibold">Email</p>
                {/* Mailto protocol opens default email client */}
                <a href="mailto:anabelinstitution@gmail.com" className="inline-block text-lg hover:text-[#F5B800] transition mt-1">
                  anabelinstitution@gmail.com
                </a>
              </div>
            </div>

            {/* Address */}
            <div className="flex items-start gap-4 group">
              <div className="p-3 rounded-full bg-white/10 group-hover:bg-[#F5B800]/20 transition">
                <svg className="w-6 h-6 text-[#F5B800]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeWidth="2" d="M12 21s-7-4.5-7-10a7 7 0 1114 0c0 5.5-7 10-7 10z"/>
                </svg>
              </div>
              <div>
                <p className="text-sm text-red-100 uppercase tracking-wider font-semibold">Location</p>
                <p className="text-base leading-relaxed mt-1">
                  1475, Park Rd,<br />
                  Opp to Samskrutha Bhavan,<br />
                  Rangoli Halla, Hassan,<br />
                  Karnataka 573201
                </p>
              </div>
            </div>

          </div>

          {/* CTA Button changed to a functional mailto link */}
          <a 
            href="mailto:anabelinstitution@gmail.com?subject=Inquiry from Website"
            className="mt-10 inline-block text-center bg-[#F5B800] text-black font-semibold py-3 px-6 rounded-full hover:scale-105 hover:shadow-lg transition-all w-max"
          >
            Send Message →
          </a>
        </div>

        {/* RIGHT SIDE MAP */}
        <div className="lg:col-span-3 relative min-h-[450px]">
          
          {/* Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent z-10 pointer-events-none"></div>

          <iframe
            title="AnaBel Location"
            src="https://maps.google.com/maps?q=1475%20Park%20Rd%20Hassan&t=&z=15&ie=UTF8&iwloc=&output=embed"
            className="absolute inset-0 w-full h-full border-0"
            loading="lazy"
          ></iframe>
        </div>

      </motion.div>
    </section>
  );
};

export default ContactUs;